import { useRef } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import inventoryServices from '@/inventory/services/services'

import { getMetricsFilters, haveMetricsFiltersChanged } from './helpers'
import { transformResponseInventoryMetrics } from './transformers'

const useInventoryMetrics = ({ storeId }) => {
  const appliedFiltersRef = useRef()
  const { data, loading, fetchData } = useFetch(inventoryServices.getInventoryMetrics, {
    transformResponse: transformResponseInventoryMetrics,
  })

  const fetchInventoryMetrics = () => fetchData({ storeId, filters: appliedFiltersRef.current })

  const applyInventoryMetricsFilters = params => {
    const filters = getMetricsFilters(params)

    if (!haveMetricsFiltersChanged(appliedFiltersRef.current, filters)) return

    appliedFiltersRef.current = filters

    fetchInventoryMetrics()
  }

  return {
    loading,
    inventoryMetrics: data,
    fetchInventoryMetrics,
    applyInventoryMetricsFilters,
  }
}

export default useInventoryMetrics
